var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Prop } from 'vue-property-decorator';
import { DateTimeslot } from '@/models/DateTimeslot';
import ErrorHandler from '@/support/ErrorHandler';
import { formatDate as format } from '@/support/String';
import LoaderCard from '@/components/loader-card/LoaderCard';
let ShowStudentsWithoutLessonsDialog = class ShowStudentsWithoutLessonsDialog extends Vue {
    constructor() {
        super(...arguments);
        this.lessonsWithoutStudents = [];
        this.lessonWithoutStudents = {};
        this.isLoading = false;
    }
    close() {
        this.$emit('input', false);
    }
    mounted() {
        this.initialize();
    }
    initialize() {
        this.isLoading = true;
        this.fetchFreeStudents();
    }
    fetchFreeStudents() {
        if (!this.dateTimeSlots) {
            return;
        }
        const dateTimeSlotsIds = this.dateTimeSlots.map((dateTimeSlot) => {
            return dateTimeSlot.id;
        });
        new DateTimeslot()
            .freeStudents({ datetimeslots: dateTimeSlotsIds })
            .then((response) => {
            this.parseData(response.data);
            this.isLoading = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    parseData(freeStudents) {
        Object.keys(freeStudents).forEach((key) => {
            this.dateTimeSlots.forEach((dateTimeSlot) => {
                if (!dateTimeSlot || !dateTimeSlot.title || dateTimeSlot.title.includes('Pauze')) {
                    return;
                }
                if (key === dateTimeSlot.id) {
                    this.lessonWithoutStudents = {
                        id: key,
                        title: dateTimeSlot.title,
                        date: dateTimeSlot.starts_at,
                        starts_at: dateTimeSlot.starts_at,
                        ends_at: dateTimeSlot.ends_at,
                        students: freeStudents[key],
                    };
                    this.lessonsWithoutStudents.push(this.lessonWithoutStudents);
                    this.lessonsWithoutStudents.sort((a, b) => {
                        const dateA = new Date(a.date);
                        const dateB = new Date(b.date);
                        return dateA - dateB;
                    });
                }
            });
        });
    }
    chooseLessonForStudent(studentId, dateTimeSlotId) {
        const url = `/students/${studentId}/roster`;
        window.location.href = url;
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Array)
], ShowStudentsWithoutLessonsDialog.prototype, "dateTimeSlots", void 0);
ShowStudentsWithoutLessonsDialog = __decorate([
    Component({
        components: {
            LoaderCard,
        },
        filters: {
            formatDate(date) {
                return !date ? '' : format(date, 'dd - LL');
            },
            formatTime(time) {
                return !time ? '' : format(time, 'HH:mm');
            },
        },
    })
], ShowStudentsWithoutLessonsDialog);
export default ShowStudentsWithoutLessonsDialog;
